export function currencyFormat(value, currency = "EUR") {
  return new Intl.NumberFormat("en-EN", {
    style: "currency",
    currency: currency
  }).format(value / 100);
}

export function priceWithVat(price, vat) {
  if (vat > 0) {
    return (price * (100 + vat)) / 100;
  } else {
    return price;
  }
}

export function rowItemTotal(
  priceOnce,
  priceMonthly,
  quantity,
  vat,
  discount,
  duration
) {
  let itemPrice =
    priceOnce === 0
      ? (priceMonthly - discount) * duration
      : priceOnce - discount;

  let total = itemPrice * quantity;

  return total + percentAmount(total, vat);
}

export function rowItemTotalVatOnly(
  priceOnce,
  priceMonthly,
  quantity,
  duration,
  vat,
  discount
) {
  let itemPrice =
    priceOnce === 0
      ? (priceMonthly - discount) * duration
      : priceOnce - discount;

  let total = itemPrice * quantity;

  return percentAmount(total, vat);
}

export function rowItemTotalWithoutVat(
  priceOnce,
  priceMonthly,
  quantity,
  discount,
  duration
) {
  let itemPrice =
    priceOnce === 0
      ? (priceMonthly - discount) * duration
      : priceOnce - discount;

  return itemPrice * quantity;
}

export function percentAmount(amount, percentage) {
  let result = 0;
  if (percentage > 0) {
    result = ((100 + percentage) * amount) / 100 - amount;
  }
  return result;
}

export function rowItemTotalInitialPayment(
  priceOnce,
  priceMonthly,
  quantity,
  vat,
  discount,
  duration,
  noPayments
) {
  let itemPrice =
    priceOnce === 0
      ? (priceWithVat(priceMonthly - discount, vat) * duration) / noPayments
      : priceWithVat(priceOnce - discount, vat);

  return itemPrice * quantity;
}
